// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"3e7e2e3f3868b0f4","297":"b5628ce94b8aac39","643":"5c92da9098cb1e9f"}[chunkId] + ".js";
};